import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from './Input';
import { withNamespaces } from 'react-i18next';

const YesNoSelect = ({ name, label, horizontal, required, hideEmptyOption = false, emptyOptionLabel, onChange, validate, t }) => {
	return (
		<Field name={name} component={Input} horizontal={horizontal} componentClass='select' label={label} required={required} onChange={onChange} validate={validate}>
			{!hideEmptyOption && <option value={''}>{emptyOptionLabel}</option>}
			<option value={true}>{t('Common_Yes')}</option>
			<option value={false}>{t('Common_No')}</option>
		</Field>
	);
};

YesNoSelect.propTypes = {
	hideEmptyOption: PropTypes.bool,
	horizontal: PropTypes.bool,
	name: PropTypes.string,
	label: PropTypes.string
};

export default withNamespaces()(YesNoSelect);